{{#if isPipelined}}
virtual function int get_beat_priority_lower_bound();
  return {{ beatPriorityUpperBoundVariable.identifier }} - {{ beatPriorityWindowWidthVariable.identifier }};
endfunction
{{/if}}
